import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import firebaseConfig from './firebase-config.temp';

let authChangedDetected;

firebase.initializeApp(firebaseConfig);

export const db = firebase.database();
export const auth = firebase.auth();

export const getProfile = async (uid) => {
  try {
    const snapshot = await db.ref(`users/${uid}`).once('value');
    const profile = snapshot.val();

    return profile;
  } catch (err) {
    // eslint-disable-next-line no-restricted-globals
    window.location.replace(`${location.protocol}//${location.host}`);
    return null;
  }
};

export const getUser = () => new Promise(async (resolve) => {
  if (!authChangedDetected) {
    auth.onAuthStateChanged(async (userObj) => {
      const user = { ...userObj };
      user.profile = await getProfile(user.uid);
      return resolve(user);
    });
  } else {
    const user = auth.currentUser;
    user.profile = await getProfile(user.uid);

    return resolve(user);
  }

  return null;
});

export const redirectToRoot = (history) => {
  const location = {
    pathname: '/',
  };

  history.replace(location);
};

